import script from "./SheetOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./SheetOverlay.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__